export function DrawerManageAuthSkeleton() {
  return (
    <div className="animate-pulse p-6">
      <div className="space-y-6">
        <div className="space-y-2">
          <div className="h-4 w-20 bg-neutral-200 rounded" />
          <div className="h-10 w-full bg-neutral-200 rounded" />
        </div>

        <div className="space-y-2">
          <div className="h-4 w-16 bg-neutral-200 rounded" />
          <div className="h-10 w-full bg-neutral-200 rounded" />
        </div>

        <div className="space-y-2">
          <div className="h-4 w-20 bg-neutral-200 rounded" />
          <div className="h-32 w-full bg-neutral-200 rounded" />
        </div>
      </div>
    </div>
  )
}
